import { useEffect, useState } from "react";
import * as Scrivito from "scrivito";

export const useScrivitoImage = (obj: Scrivito.Obj) => {
  const [productImage, setProductImage] = useState<string | null>(null);
  const [fetching, setFetching] = useState<boolean>(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (obj && !productImage && !fetching && !error) {
      Scrivito.load(() => obj.contentUrl())
        .then((url) => {
          if (url) {
            setProductImage(url);
          }
        })
        .catch((err) => {
          console.error("Error loading product image:", err);
          setError(err);
        })
        .finally(() => {
          setFetching(false);
        });
    }
  }, [error, fetching, obj, productImage]);

  return {
    productImage,
    fetching,
  };
};
